jQuery(document).ready(function($) {

    // Quote Slider
    new Swiper('.quote-swiper', {
        grabCursor: true,
        speed: 700,
        slidesPerView: 1,
        spaceBetween: 16,
        pagination: {
            el: '.quote-swiper .swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            768: {
                slidesPerView: 1.2,
                spaceBetween: 40,
            },
            1365: {
                slidesPerView: 1.5,
                spaceBetween: 40,
            },
            1920: {
                slidesPerView: 1.5,
                centeredSlides: true,
                spaceBetween: 40,
            },
        },
    });

    // Kila Slider
    new Swiper('.swiper-container.kila-slider', {
        observer: true,
        observeParents: true,
        watchOverflow: true,
        loop: true,
        grabCursor: true,
        autoplay: {
            delay: 7000,
        },
        speed: 500,
        preloadImages: false,
        lazy: {
            loadPrevNext: true,
        },
        navigation: {
            nextEl: '.kila-slider .swiper-button-next',
            prevEl: '.kila-slider .swiper-button-prev',
        },
        pagination: {
            el: '.kila-slider .swiper-pagination',
            clickable: true,
        },
    });

    // Brands Slider
    new Swiper('.swiper-container.brand-slider', {
        observer: true,
        observeParents: true,
        watchOverflow: true,
        grabCursor: true,

        slidesPerView: 1.1,
        spaceBetween: 16,
        speed: 700,
        pagination: {
            el: '.brand-slider .swiper-pagination',
            clickable: true,
            type: 'progressbar',
        },
        navigation: {
            nextEl: '.brands .swiper-button-next',
            prevEl: '.brands .swiper-button-prev',
        },
        breakpoints: {
            480: {
                slidesPerView: 1.25,
                spaceBetween: 16,
            },
            540: {
                slidesPerView: 1.4,
                spaceBetween: 20,
            },

            640: {
                slidesPerView: 1.6,
                spaceBetween: 20,
            },

            768: {
                slidesPerView: 2.2,
                slidesPerGroup: 2,
                spaceBetween: 30,
            },

            960: {
                slidesPerView: 2.7,
            },
            1200: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },

            1440: {
                slidesPerView: 4,
                slidesPerGroup: 4,
            },

        },
    });

    // Guide Slider
    new Swiper('.swiper-container.guide-slider', {
        observer: true,
        observeParents: true,
        watchOverflow: true,
        grabCursor: true,

        slidesPerView: 1.1,
        spaceBetween: 16,
        speed: 700,
        pagination: {
            el: '.guide-slider .swiper-pagination',
            clickable: true,
            type: 'progressbar',
        },
        navigation: {
            nextEl: '.guide .swiper-button-next',
            prevEl: '.guide .swiper-button-prev',
        },
        breakpoints: {
            480: {
                slidesPerView: 1.25,
            },
            540: {
                slidesPerView: 1.4,
            },

            640: {
                slidesPerView: 2.4,
            },

            768: {
                slidesPerView: 2.6,
                slidesPerGroup: 3,
            },

            960: {
                slidesPerView: 3.7,
            },
            1200: {
                slidesPerView: 4,
                slidesPerGroup: 4,
            },

            1440: {
                slidesPerView: 5,
                slidesPerGroup: 5,
            },

        },
    });

    // Popuplar Slider
    new Swiper('.swiper-container.popular-slider', {
        observer: true,
        observeParents: true,
        watchOverflow: true,
        grabCursor: true,
        slidesPerView: 1.94,
        spaceBetween: 0,
        speed: 700,

        pagination: {
            el: '.popular-slider .swiper-pagination',
            clickable: true,
            type: 'progressbar',
        },
        navigation: {
            nextEl: '.popular .swiper-button-next',
            prevEl: '.popular .swiper-button-prev',
        },
        breakpoints: {
            540: {
                slidesPerView: 2.5,
            },

            768: {
                slidesPerView: 2.94,
            },
            920: {
                slidesPerView: 3.5,
            },
            1200: {
                slidesPerView: 4,
                slidesPerGroup: 4,
            },
            1366: {
                slidesPerView: 5,
                slidesPerGroup: 5,
            },
        },
    });

    // Campaign Slider
    new Swiper('.archive-campaigns .swiper-container', {
        observer: true,
        observeParents: true,
        watchOverflow: true,
        grabCursor: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 16,
        speed: 700,
        pagination: {
            el: '.archive-campaigns .swiper-pagination',
            type: 'progressbar',
        },
        navigation: {
            nextEl: '.archive-campaigns .swiper-button-next',
            prevEl: '.archive-campaigns .swiper-button-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 25,
            },
            1367: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
        },
    });

    // Campaign Slider
    new Swiper('.archive-campaigns .swiper-container-2-col', {
        observer: true,
        observeParents: true,
        watchOverflow: true,
        grabCursor: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 16,
        speed: 700,
        pagination: {
            el: '.archive-campaigns .swiper-pagination',
            type: 'progressbar',
        },
        navigation: {
            nextEl: '.archive-campaigns .swiper-button-next',
            prevEl: '.archive-campaigns .swiper-button-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                slidesPerGroup: 2,
                spaceBetween: 25,
            },
        },
    });

    // Product Slider — `.product-slider--native` is the feature-flagged
    // overflow-x-scroll alternative; it shares the swiper-* markup but skips
    // Swiper initialization so CSS can take over.
    $('.product-slider').not('.product-slider--native').each(function() {
        var index = $(this).data('id');
        var swiper_index = '.swiper-container-' + index;
        var prev = '.swiper-button-prev-' + index;
        var next = '.swiper-button-next-' + index;
        var pagination = '.swiper-pagination-' + index;

        new Swiper(swiper_index, {
            observer: true,
            observeParents: true,
            watchOverflow: true,
            grabCursor: true,
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 0,
            speed: 700,
            pagination: {
                el: pagination,
                type: 'progressbar',
            },
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
                1200: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                },
                1366: {
                    slidesPerView: 5,
                    slidesPerGroup: 5,
                },
            },
        });

    });

    // Product cat slider
    const swiper = new Swiper('.prodcat', {
        slidesPerView: 'auto',
        spaceBetween: 16,
        slidesPerGroup: 2,
        slidesOffsetBefore: 24,
        slidesOffsetAfter: 24,
        watchOverflow: true,
        navigation: {
            nextEl: '.archive-categories  .swiper-button-next',
            prevEl: '.archive-categories  .swiper-button-prev',
        },
        breakpoints: {
            1367: {
                spaceBetween: 32,
            },
            767: {
                spaceBetween: 24,
            },
        },
        grabCursor: true,
        hideOnClick: true,

        on: {
            slideChange: function() {
                const prodcatElement = document.querySelector('.prodcat');

                if (this.activeIndex === 0) {
                    prodcatElement.classList.add('hide-before');
                    prodcatElement.classList.remove('hide-last');
                } else if (this.isEnd) {
                    prodcatElement.classList.add('hide-last');
                    prodcatElement.classList.remove('hide-before');
                } else {
                    prodcatElement.classList.remove('hide-before', 'hide-last');
                }
            },
            sliderMove: function() {
                const prodcatElement2 = document.querySelector('.prodcat');
                const nextButtonElement = document.querySelector(
                    '.archive-categories .swiper-button-next');
                const prevButtonElement = document.querySelector(
                    '.archive-categories .swiper-button-prev');

                if (window.innerWidth < 768) {
                    prodcatElement2.classList.add('hide-arrows');
                    nextButtonElement.classList.add('hidden');
                    prevButtonElement.classList.add('hidden');
                }
            },
        },
    });

    // Hide navigation if all slides fit
    function checkProdcatOverflow() {
        const container = document.querySelector('.archive-categories');
        if (!container) return;

        const nextBtn = container.querySelector('.swiper-button-next');
        const prevBtn = container.querySelector('.swiper-button-prev');
        const prodcatElement = container.querySelector('.prodcat');

        if (swiper.isLocked) {
            nextBtn?.classList.remove('visible');
            prevBtn?.classList.remove('visible');
            prodcatElement?.classList.add('hide-before', 'hide-last');
        } else {
            nextBtn?.classList.add('visible');
            prevBtn?.classList.add('visible');
            prodcatElement?.classList.remove('hide-before', 'hide-last');
            if (swiper.activeIndex === 0) {
                prodcatElement?.classList.add('hide-before');
            }
        }
    }

    checkProdcatOverflow();
    window.addEventListener('resize', checkProdcatOverflow);

    // Add click event listener to the slider
    const sliderElement = document.querySelector('.prodcat');

    if (sliderElement) {
        sliderElement.addEventListener('click', function() {
            // Add the 'hide arrows' class when the slider is clicked
            this.classList.add('hide-arrows');
        });
    }

    let $loop = true;
    if ( $(".swiper-hero .swiper-slide").length === 1 ) {
        $loop = false;
    }
    const heroSwiper = new Swiper('.swiper-hero', {
        slidesPerView: 1,
        navigation: {
            nextEl: '.hero .swiper-button-next',
            prevEl: '.hero .swiper-button-prev',
        },
        pagination: {
            el: '.hero .swiper-pagination',
            clickable: true,
        },
        loop: $loop,
        autoplay: {
            delay: 7000,
            disableOnInteraction: true,
        },
    });

    // Pausa autoplay vid hover och focus (pauseOnMouseEnter kräver Swiper 7+)
    const heroContainer = document.querySelector('.swiper-hero');
    if (heroContainer) {
        heroContainer.addEventListener('mouseenter', () => {
            heroSwiper.autoplay.stop();
        });
        heroContainer.addEventListener('mouseleave', () => {
            heroSwiper.autoplay.start();
        });
        heroContainer.addEventListener('focusin', () => {
            heroSwiper.autoplay.stop();
        });
        heroContainer.addEventListener('focusout', () => {
            heroSwiper.autoplay.start();
        });
    }

    requestAnimationFrame(function() {
        const el = document.querySelector('.swiper-hero .swiper-slide-duplicate');
        if (el) {
            window.checkForContentVisibility(el);
        }
    });
});
